export const JOB_TITLE_MAX_LENGTH = 50;

export const PHONE_NUMBER_PLACEMENT_VARIATIONS = {
  firstPanelLoanAppRequired: 0,
  lastPanelGettingStartedOptional: 1,
  lastPanelGettingStartedRequired: 2,
};
